import styled from "styled-components";
import {
  space,
  color,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
} from "styled-system";

export const StyledIconButton = styled.button`
  display: flex;
  align-items: center;
  padding: 12px;
  background: none;
  border: none;
  cursor: pointer;
  ${({ iconMargin }) =>
    iconMargin &&
    `
    svg {
      margin-right: ${iconMargin};
    }
  `}
  ${space}
  ${color}
    ${layout}
    ${flexbox}
    ${grid}
    ${background}
    ${border}
    ${position}
    ${shadow}
`;
